import { BaseRecord } from '@refinedev/core';
import { create } from 'zustand';

// Inlined from the retired v1 TopicList (R15b-b3).
export interface Topic extends BaseRecord {
  id: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  descendants: any[];
}

export interface TopicStoreConfig {
  storageKey: string;
}

export interface TopicState extends BaseRecord {
  activeTopic: Topic | null;
  loading: boolean;
  error: null;
  activeTopicId: null;
  topicsCache: Record<string | number, Topic[]>;
}

interface TopicActions {
  setActiveTopic: (topic: Topic | null) => void;
  setActiveTopicId: (topicId: any) => void;
  setTopics: (experienceId: string | number, topics: Topic[]) => void;
  getTopics: (experienceId: string | number) => Topic[];
  clearTopics: (experienceId: string | number) => void;
  setLoading: (loading: boolean) => void;
}

type TopicStore = TopicState & TopicActions & { config: TopicStoreConfig };

export const topicStoreConfig: TopicStoreConfig = {
  storageKey: 'topicState',
};

export const useTopicStore = create<TopicStore>((set, get) => ({
  activeTopic: null,
  loading: false,
  error: null,
  activeTopicId: null,
  topicsCache: {},
  config: topicStoreConfig,

  setActiveTopic: (topic: any) => set({ activeTopic: topic }),

  setActiveTopicId: (topicId: any) => set({ activeTopicId: topicId }),

  setTopics: (experienceId, topics) =>
    set((state) => ({
      topicsCache: {
        ...state.topicsCache,
        [experienceId]: topics,
      },
    })),

  getTopics: (experienceId) => get().topicsCache[experienceId] ?? [],

  clearTopics: (experienceId) =>
    set((state) => {
      const newCache = { ...state.topicsCache };
      delete newCache[experienceId];
      return { topicsCache: newCache };
    }),

  setLoading: (loading) => set({ loading }),
}));

export const selectActiveTopicId = (state: TopicStore) => state.activeTopicId ?? null;

export const selectActiveTopic = (state: TopicStore) => state.activeTopic ?? null;
